import { rootStore } from 'store/root';

const { nxlApi } = window;

nxlApi.appsInstaller.sub(async (key: string, data: any) => {
    switch (key) {
        case 'setDefaultPaths':
            rootStore.systemInfo.updateDefaultInstallPath(data.installPath);
            break;
    }
});
